import React from 'react';
import { STATUS_COLORS } from './ProgressCircle';

export default function CategoryBadge({ category, className = '' }) {
	const c = STATUS_COLORS[category] || STATUS_COLORS.Strong;
	return (
		<span
			className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider ${className}`}
			style={{ color: c.fg, backgroundColor: c.bg }}
		>
			<span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.ring }} />
			{category}
		</span>
	);
}
